<template>
  <div class="icp-footer">
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">赣ICP备2020010906号-3</a>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="less">
.icp-footer {
  text-align: center;
  font-size: 12px;
  line-height: 1.5;

  a {
    color: #909399;
    text-decoration: none;

    &:hover {
      color: #606266;
      text-decoration: underline;
    }
  }
}
</style>
